import { sendGetRequest, sendPostRequest } from "services/apiService";

export const getAppsumoLicenseKeyApi = async (code: string) => {
  const resp = await sendGetRequest<
    APIResponse<{
      isSuccess: true;
      appsumoLicenseKey: string;
      message?: string;
    }>
  >(`/appsumo/license-key/${code}`);

  if (resp.isSuccess) {
    return resp;
  }
  throw new Error(resp?.message);
};

export const createCustomerAndSubscriptionByAppsumoApi = async (): Promise<
  APIResponse<{ isSuccess: boolean; error?: Error }>
> => {
  const resp = await sendPostRequest<
    undefined,
    APIResponse<{ isSuccess: boolean; error: Error }>
  >("/chargebee/appsumo/customer-and-subscription", undefined);

  if (resp.isSuccess) {
    return resp;
  }

  throw new Error(resp?.error?.message);
};
